import { useContext } from "react";
import { OverdriveContext } from "../context/OverdriveProvider";

const useOverdrive = () => {
  const [overdrive, dispatchOd] = useContext(OverdriveContext);
  return { overdrive, dispatchOd };
};

export default useOverdrive;
